module.exports = __webpack_public_path__ + "static/media/inclusive-volume.7e0c5b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inclusive-volume.svg
// module id = ./src/assets/images/inclusive-volume.svg
// module chunks = 0